import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './WarningModal.styles';
import { Modal } from '@/components/UI/Modal';
import { Button } from '@/components/UI/Button/Button';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void | Promise<void>;
  title: string;
  description: string;
  icon?: string;
  iconSize?: number;
  actions?: React.ReactNode;
  buttonText?: string;
  dataTestId?: string;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  onClose,
  title,
  icon,
  buttonText,
  dataTestId,
  description,
  actions,
  iconSize = 35,
}) => {
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();

  return (
    <Modal
      isInPortal
      dataTestId={dataTestId}
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={isDesktop ? 445 : 345}
    >
      <S.Content>
        {icon && (
          <S.Icon>
            <IconBox
              $filename={icon}
              $width={iconSize}
              $height={iconSize}
              $iconWidth={iconSize}
              $iconHeight={iconSize}
            />
          </S.Icon>
        )}
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
        {actions ? (
          <S.ActionsContainer>{actions}</S.ActionsContainer>
        ) : (
          <Button
            appearance="secondary"
            isFullWidth
            borderRadius={14}
            onClick={onClose}
          >
            {buttonText ?? t('common.got_it')}
          </Button>
        )}
      </S.Content>
    </Modal>
  );
};
